import { Model } from './model';

export class Estensione extends Model {
  
    static apiUrl: string = "estensioni";

    slug: string;
    external_id: string;
    claim_number: string;
    configuration: any;
    enabled: boolean;
  
  
    deserialize(input: any): Estensione {
      let retV: Estensione = new Estensione();
      retV = super.deserialize(input) as Estensione;
      if (retV.configuration === null || retV.configuration === undefined) {
        retV.configuration = null;
      } else if (typeof retV.configuration === 'string') {
        retV.configuration = JSON.parse(retV.configuration);
      }
      this.configuration = retV.configuration;
      return retV;
    }
  
  
  }
